import React, { useEffect } from 'react';
import ChartLoader from '../Loaders/ChartLoader';
import Highcharts from 'highcharts/highstock';

require('highcharts/modules/drag-panes')(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});
let chart;

const HighChartCustomGraph = (props) => {
  useEffect(() => {
    chart = new Highcharts.chart(props.chartId, props.chartObj);
    if (chart) props.generatedChartObject(chart);
  }, [props, props.chartObj]);

  return (
    <>
      {props.isLoading && <ChartLoader height="150" width="600" />}
      <div
        id={props.chartId}
        style={{ display: props.isLoading ? 'none' : 'block' }}
      ></div>
    </>
  );
};

export default HighChartCustomGraph;
